import { Surfaces } from "@netlify/sdk--ui-core";
import React from "react";
import { useNetlifySDK } from "../../use_netlify_sdk.js";

export type SiteBuildDeployConfigurationSurfaceProps = {
  /**
   * Content to render within the element.
   */
  children?: React.ReactNode | undefined;

  /**
   * A class property to attach to the element.
   *
   * @see {@link !Element.className}
   */
  className?: string | undefined;
};

/**
 * A container element used to render the Project Build & Deploy Configuration surface. This component
 * will take care of styling your component so it looks good in the ** Project configuration > Build & deploy**
 * section of the Netlify UI.
 *
 * <!-- TODO(ndhoule): Add a screenshot here -->
 *
 * @param props
 * @see Surfaces.SiteBuildDeployConfiguration
 * @example
 * ```tsx
 * import { SiteBuildDeployConfigurationSurface } from "@netlify/sdk/react/components";
 *
 * <SiteBuildDeployConfigurationSurface>
 *   <div>Your surface content goes here</div>
 * </SiteBuildDeployConfigurationSurface>
 * ```
 */
export const SiteBuildDeployConfigurationSurface = ({
  className,
  children,
  ...otherProps
}: SiteBuildDeployConfigurationSurfaceProps) => {
  const sdk = useNetlifySDK();

  return (
    <section
      id={`section-${Surfaces.SiteBuildDeployConfiguration}-${sdk.extension.slug}`}
      className={className}
      {...otherProps}
    >
      {children}
    </section>
  );
};
